module.exports = __webpack_public_path__ + "static/img/goods03.63256f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goods03.png
// module id = CC4m
// module chunks = 1